"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
* Copyright (c) Trainline Limited, 2017. All rights reserved.
* See LICENSE.txt in the project root for license information.
*/
var React = require("react");
var utils_1 = require("./utils");
var createStyle = function (styles) { return (styles.filter(Boolean).reduce(function (acc, next) { return (__assign({}, acc, next)); }, {})); };
var createClassName = function (classnames) { return (classnames.filter(Boolean).join(' ')); };
exports.createSkeletonElement = function (type, pendingStyle) {
    var ExportedComponent = function (// tslint:disable-line
        props, _a // tslint:disable-line
    ) {
        var skeletor = _a.skeletor;
        var isPending;
        var styling;
        if (skeletor) {
            isPending = skeletor.isPending;
            styling = skeletor.styling;
        }
        var newProps = __assign({}, props);
        if (isPending) {
            var contextStyle = typeof styling === 'function' ? styling() : undefined;
            newProps.style = createStyle([
                props.style,
                typeof contextStyle !== 'string' && contextStyle,
                typeof pendingStyle !== 'string' && pendingStyle
            ]);
            newProps.className = createClassName([
                props.className,
                typeof contextStyle === 'string' && contextStyle,
                typeof pendingStyle === 'string' && pendingStyle
            ]);
        }
        // tslint:disable-next-line:no-any
        return React.createElement(type, newProps);
    };
    ExportedComponent.contextTypes = utils_1.contextTypes;
    return ExportedComponent;
};
//# sourceMappingURL=createSkeletonElement.js.map


//////////////////
// WEBPACK FOOTER
// /Users/alexandrer/development/react-skeletor/lib/createSkeletonElement.js
// module id = 136
// module chunks = 0